export default __webpack_public_path__ + "static/media/mv.480ce7a0.svg";